import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useAuth0 } from '../auth/auth';
import { ERoutes } from '../assets/constants/routes';
import { FooterComponent } from '../components/organisms/organisms.index';
import { useSelector } from 'react-redux';
import { makeSelectCurrentUser } from '../store/current-user/current-user.selectors';

export const RoutesConfig = (routes: any) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();
  const currentUser = useSelector(makeSelectCurrentUser());
  const checkUser = currentUser.isOfLegalAge && currentUser.legalConditionsAccepted;

  return (
    <Switch>
      <Redirect from='/' to='/home' exact={true} />
      {routes.map((route: any, i: number) => (
        <Route
          key={route.key || i}
          path={route.path}
          exact={route.exact}
          strict={route.strict}
          render={props => {

            if (route.restricted) {
              if (loading) {
                return;
              }

              if (!isAuthenticated && props.location.search.indexOf('state') < 0) {
                console.log('Redirecting to login in order to access a restricted route');
                loginWithRedirect();
                return;
              }
            }

            if (isAuthenticated && checkUser === false && route.path !== ERoutes.POLICY) {
              return <Redirect to={ERoutes.POLICY} />;
            }

            if (route.path === ERoutes.POLICY && checkUser) {
              return <Redirect to={`${ERoutes.ONBOARDING}${ERoutes.HOME}`} />;
            }

            return (
              <React.Fragment>
                <route.component {...props} route={route} />{' '}
                <FooterComponent />
              </React.Fragment>
            );
          }}
        />
      ))}
    </Switch>
  );
};
